module.exports = __webpack_public_path__ + "static/media/logo-navbar.869175e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-navbar.svg
// module id = 1271
// module chunks = 0